import React from 'react';

const ThankYou = () => (
  <section className="">
    <div className="container">
      <div className="row wow fadeInUp">
        <div className="col-md-12 col-md-ml-auto col-12">
          <div className="card">
            <div className="card-img-top" />
            <div className="card-body">
              <div className="text-secondary small">
                <h2>Message received!</h2>
              </div>
              <h2 className="display-1">We got your message! Thank you!</h2>
              <h2>We'll answer as soon possible!</h2>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </section>
);
export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/ThankYou.js